import { z } from 'zod'

export const usuarioFormSchema = z.object({
  nome: z.string().min(1, 'Nome obrigatorio').max(150),
  email: z.string().email('E-mail invalido'),
  senha: z.string().min(6, 'Senha deve ter ao menos 6 caracteres').max(100).optional().or(z.literal('')),
  ativo: z.boolean().optional(),
  roles: z.array(z.string()).optional(),
})

export type UsuarioFormData = z.infer<typeof usuarioFormSchema>

export const roleFormSchema = z.object({
  nome: z.string().min(1, 'Nome obrigatorio').max(80),
  descricao: z.string().max(200).optional().or(z.literal('')),
  ativo: z.boolean().optional(),
  permissoes: z.array(z.number()).optional(),
})

export type RoleFormData = z.infer<typeof roleFormSchema>
